// Navigation intent only. Never authorizes payment, a company or Pro access.
export function hasUpgradeIntent(search: string): boolean {
  const values = new URLSearchParams(search).getAll("upgrade");
  return values.length === 1 && values[0] === "1";
}

export function upgradeIntentSearch(search: string): string {
  return hasUpgradeIntent(search) ? "?upgrade=1" : "";
}

export function postLoginPath(companyId: string | number, search: string): string | null {
  const id = String(companyId);
  if (!/^[1-9]\d*$/.test(id)) return null;
  return hasUpgradeIntent(search)
    ? `/company/${id}/settings?upgrade=1`
    : `/company/${id}/dashboard`;
}
